import { useRef, useEffect, useCallback } from 'react';

export default () => {
	const isMountedRef = useRef(false);

	useEffect(() => {
		isMountedRef.current = true;

		return () => {
			isMountedRef.current = false;
		};
	}, []);

	return useCallback(() => isMountedRef.current, []);
};
